// サイドメニューの「ログアウト」。
// store のトークンは「遷移の前に」消す。残したまま /login へ遷移すると、/login の setAccessToken middleware が
// メモリ上のトークンを保ち(ストレージ消失時のフォールバック)、alreadyAuth が /registerCodes へ戻してしまい、
// 利用者にはログアウトできていないように見える。あわせて、/login で走る通信が
// 「直前までトークンがあったのにセッション無し」の誤検知として Sentry に送られるのも防ぐ。
// currentUser はヘッダー等のテンプレートが参照しているため、従来どおり遷移後に少し遅らせて消す
export const CURRENT_USER_CLEAR_DELAY_MS = 500

export const logout = async ({
  store,
  authRepository,
  router,
  authToken,
  wait = (fn, ms) => setTimeout(fn, ms)
}) => {
  if (authToken && typeof authToken.reportSignOut === 'function') {
    authToken.reportSignOut('user-logout')
  }
  store.commit('setAccessToken', undefined)
  await authRepository.logout()
  router.push('/login')
  wait(() => {
    store.commit('setCurrentUser', undefined)
  }, CURRENT_USER_CLEAR_DELAY_MS)
}
